import React, { FC, isValidElement, ReactNode } from "react";
import classNames from "classnames";
import { ScanPageLeftItemEnum, ScanPageBodyItemEnum, ScanPageLeftProps } from "../../interface";

const Left: FC<ScanPageLeftProps> = props => {
  const { children, className, style, } = props;
  // const renderChildren = (childrenNodes: ReactNode): ReactNode => {
  //   return React.Children.map(childrenNodes, child => {
  //     const childElement = child as React.FunctionComponentElement<ScanPageLeftProps>;
  //     if (!isValidElement(childElement)) return null;
  //     if (!childElement.type) return null;
  //     const { displayName } = childElement.type;
  //     if (displayName && displayName in ScanPageLeftItemEnum) {
  //       return React.cloneElement(childElement);
  //     } else {
  //       console.error(
  //         'Warning: ScanPageLeft has a child which is not a FormItem or Custom component',
  //       );
  //     }
  //   });
  // };
  const classes = classNames('scan-page-body-left', className);
  return (
    <div className={classes} style={style}>{children}</div>
  );
};

Left.displayName = ScanPageBodyItemEnum.Left;

export default Left;
